import { render, staticRenderFns } from "./SpecialtySelect.vue?vue&type=template&id=57234284&scoped=true&"
import script from "./SpecialtySelect.vue?vue&type=script&lang=ts&setup=true&"
export * from "./SpecialtySelect.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./SpecialtySelect.vue?vue&type=style&index=0&id=57234284&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57234284",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57234284')) {
      api.createRecord('57234284', component.options)
    } else {
      api.reload('57234284', component.options)
    }
    module.hot.accept("./SpecialtySelect.vue?vue&type=template&id=57234284&scoped=true&", function () {
      api.rerender('57234284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsSchedule/components/SpecialtySelect.vue"
export default component.exports